/* @flow */

import formatarReal from '../../utils/formatar-real';
import { MOEDA } from '../../utils/constants';

import { type Produto } from '../types';

const precoComPromocao = ({
    precoSemPromocao,
    preco,
}: {
    precoSemPromocao: number,
    preco: number,
}) => `
    <small style="text-decoration: line-through">
        ${formatarReal(precoSemPromocao, MOEDA)}
    </small>
    <h6>${formatarReal(preco, MOEDA)}</h6>
`;

const aPartirDe = (precoMinimo: number) => `
    <small>A partir de</small>
    <br>
    ${formatarReal(precoMinimo, MOEDA)}
`;

const precoSimples = (preco: number) => formatarReal(preco, MOEDA);

const viewPreco = ({ preco, precoMinimo, precoSemPromocao }: Produto) => {
    if (precoMinimo > preco) {
        return aPartirDe(precoMinimo);
    }

    if (precoSemPromocao) {
        return precoComPromocao({ preco, precoSemPromocao });
    }

    return precoSimples(preco);
};

export default viewPreco;
